import { render, staticRenderFns } from "./table-diretrizes-fase-plenaria.vue?vue&type=template&id=d82a61d0&scoped=true&"
import script from "./table-diretrizes-fase-plenaria.vue?vue&type=script&lang=js&"
export * from "./table-diretrizes-fase-plenaria.vue?vue&type=script&lang=js&"
import style0 from "./table-diretrizes-fase-plenaria.vue?vue&type=style&index=0&id=d82a61d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d82a61d0",
  null
  
)

export default component.exports